import Link from "next/link";
import React from "react";
import {useTranslation} from "next-i18next";

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function ScoreExplained () {
    const { t } = useTranslation();

    return (
        <>
            <Link href={'/score'} className={'p-1 text-center small fst-italic link-primary'}>
                {t('explain.score', { ns: 'glossary' })}
            </Link>
        </>
    );
}